module.exports = __webpack_public_path__ + "img/psm_login_logo.28fbc889.png";